import { apiClient } from '../apiClient';

/**
 * Build RPC endpoint URL (no company param for tenant routes)
 */
const buildUrl = (path: string): string => {
  return `/api/rpc/tenants${path}`;
};

/**
 * RPC client for tenant-related operations
 * All endpoints return { ok: true, data } or { ok: false, error }
 */
const rpcTenants = {
  /**
   * Get list of tenants for current user
   */
  getMyTenants() {
    return apiClient.post(buildUrl('/get-my-tenants'), {});
  },

  /**
   * Switch to a different tenant
   */
  switchTenant(payload: { tenantId: string }) {
    return apiClient.post(buildUrl('/switch-tenant'), payload);
  },

  /**
   * Link a user to a company (SuperAdmin only)
   */
  linkTenant(payload: {
    userId: string;
    tenantId: string;
    role?: string;
    email?: string;
    fullName?: string;
    sourceCompanySlug?: string;
  }) {
    return apiClient.post(buildUrl('/link-tenant'), payload);
  },

  /**
   * Unlink a user from a company (SuperAdmin only)
   */
  unlinkTenant(payload: {
    userId: string;
    tenantId: string;
    sourceCompanySlug?: string;
    email?: string;
    bidirectional?: boolean;
  }) {
    return apiClient.post(buildUrl('/unlink-tenant'), payload);
  },
};

export default rpcTenants;

